// Guide reviewers (29 Oct 2026, migration 000190): a Manager names people of
// the customer who read one guide's progress and notes. It stays on the list
// and only talks: it never opens a guide, adds a reviewer or removes one,
// since each sends a bell row or changes who reads a person's notes.

import type { Walkthrough } from './types'

export const guideReviewers: Walkthrough = {
  slug: 'guide-reviewers',
  title: 'Guide reviewers',
  summary:
    'Shows how a Manager names reviewers for a guide and what a reviewer can read. Nothing is opened, added or removed.',
  added: '2026-10-29',
  steps: [
    {
      page: 'admin-guides',
      feature: 'people/guide-reviewers',
      say: 'A guide can have reviewers: people of the customer who read where each person got to and their notes, without being Managers.',
    },
    {
      page: 'admin-guides',
      feature: 'people/guide-reviewers',
      say: 'Open a guide and go to the People tab. Under Reviewers, paste their emails and click Add reviewer. Each must be a Platinum user of this customer, a Realm admin included, and not a Manager.',
    },
    {
      page: 'admin-guides',
      feature: 'people/guide-review',
      say: 'A reviewer gets a bell notification and finds the guide here. They read the Responses tab only: no conversations, no tags, no export, and no changes to the guide.',
    },
    {
      page: 'admin-guides',
      feature: 'people/guide-reviewers',
      say: 'Every person in the guide sees the reviewers named on their page, and the agent tells them who reads their notes. Remove takes a reviewer off at any time.',
    },
  ],
}
